/* RevitalGlow - product page delivery line.
   The theme prints the delivery date with the weekday ("Monday September 28th"),
   which is too long to sit on one line next to the dot. Drop the weekday so the
   line reads "Ready to ship - arrives by September 28th" - same wording, one line.
   Every word of the copy is kept; only the weekday is removed from the date. */
(function () {
  var WEEKDAY = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday)\s+/;

  function shorten() {
    var dates = document.querySelectorAll('.cutom_svn_date');
    for (var i = 0; i < dates.length; i++) {
      var text = dates[i].textContent.trim();
      if (WEEKDAY.test(text)) {
        dates[i].textContent = text.replace(WEEKDAY, '');
      }
    }
  }

  shorten();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', shorten);
  }
  /* The buy box re-renders when a bundle or subscription option is picked. */
  document.addEventListener('variant:change', shorten);
  window.addEventListener('load', shorten);
})();